import { render, staticRenderFns } from "./BillingPendencyList.vue?vue&type=template&id=5eda9fe2"
import script from "./BillingPendencyList.vue?vue&type=script&lang=ts"
export * from "./BillingPendencyList.vue?vue&type=script&lang=ts"
import style0 from "./BillingPendencyList.vue?vue&type=style&index=0&id=5eda9fe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports